export const daysData = [
  {
    id: 'monday',
    label: 'Monday',
  },
  {
    id: 'sunday',
    label: 'Sunday',
  },
];

export const weeksData = [...Array(53).keys()]
  .slice(1)
  .filter(num => num % 4 === 0)
  .reduce((acc, cur) => [...acc, { id: cur, label: cur }], []);

export const stepsData = [
  {
    id: 1,
    label: 'Basic Info',
  },
  {
    id: 2,
    label: 'Strength Training',
  },
  {
    id: 3,
    label: 'Cardio',
  },
  {
    id: 4,
    label: 'Diet',
  },
  {
    id: 5,
    label: 'Additional Goals',
  },
];

export const minMaxOptions = [...Array(8).keys()].reduce(
  (acc, cur) => [...acc, { id: cur, label: cur }],
  [],
);

export const watersData = [
  {
    id: 1,
    label: 'No Goal (not recommended)',
  },
  {
    id: 2,
    label: '½ Gallon (not recommended)',
  },
  {
    id: 3,
    label: '¾ Gallon',
  },
  {
    id: 4,
    label: '1 Gallon',
  },
  {
    id: 5,
    label: '1¼ Gallons',
  },
  {
    id: 6,
    label: '1½ Gallons',
  },
  {
    id: 7,
    label: '1¾ Gallons',
  },
  {
    id: 8,
    label: '2 Gallons',
  },
];

export const ouncesData = [
  {
    id: 8,
    label: '8 oz',
  },
  {
    id: 12,
    label: '12 oz',
  },
  {
    id: 16,
    label: '16 oz',
  },
  {
    id: 20,
    label: '20 oz',
  },
  {
    id: 24,
    label: '24 oz',
  },
  {
    id: 32,
    label: '32 oz',
  },
  {
    id: 40,
    label: '40 oz',
  },
  {
    id: 64,
    label: '64 oz (½ gallon)',
  },
  {
    id: 128,
    label: '128 oz (1 gallon)',
  },
  {
    id: 0,
    label: 'Do not track cups (not recommended)',
  },
];

// PDF Text

export const dietData = {
  macroCounting: 'plan, weigh, and track every ingredient I eat',
  noProcessedFoods: 'abstain from processed foods',
  intermittentFasting: 'an intermittent fasting schedule',
  carbTiming: 'time my carbohydrate glycemic intake with my workouts',
  noAlcohol: 'abstain from alcohol',
};

export const cheatMealsData = {
  0: '',
  1: 'with no more than one cheat meal per week',
  2: 'with no more than two cheat meals per week',
};

export const watersText = {
  2: 'half a gallon',
  3: 'three-fourths of a gallon',
  4: 'one gallon',
  5: 'one and a quarter gallons',
  6: 'one and a half gallons',
};

export const additionalsData = [
  '20 Minutes Cleaning',
  '30 Minute Walk',
  '5 Job Applications',
  '8 Hours of Sleep',
  'Call Family/Friends',
  'Content Creation',
  'Declutter One Space',
  'Duolingo',
  'Floss',
  'Invest $100',
  'Journal',
  'Learn a New Word',
  'Listen to a Podcast',
  'Listen To Affirmations',
  'Meditate',
  'Moisturize Skin',
  'No Alcohol',
  'Practice Deep Breathing',
  '30 Minutes of an Audiobook',
  'Read 30 Minutes',
  'Side Hustle',
  'Stretch Routine',
  'Take a Power Nap',
  'Tanning Outside',
  'Teeth Whitening',
  'Try a New Recipe',
  'Watch a TED Talk',
  'Write 10 Minutes',
  'Write a Thank You Note',
  'Yoga',
];
